import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './Weather.css'
import { CSSTransition, TransitionGroup } from 'react-transition-group';


const Weather = () => {
  const [city, setCity] = useState('');
  const [weatherData, setWeatherData] = useState(null);
	const [forecastData, setForecastData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
	const [counter, setCounter] = useState(0);
  const [isRowAppended, setIsRowAppended] = useState(false);

  // API key for OpenWeatherMap API
  const apiKey = 'c50692338f071813255ef459f0d9822a';

  const handleInputChange = (e) => {
    setCity(e.target.value);
  };

  const getWeatherData = async () => {
    setError(''); // Clear any previous error messages
		setCity(''); // Clear input field
		setWeatherData(null); // Clear any previous weather data
		setCounter(0); // Reset animation counter
    setIsRowAppended(false); // Reset row appended state

    if (!city) {
      setError('Please enter a city name.');
      return;
    }

    const timeout = setTimeout(() => {
      setError('Error fetching weather data. Did you enter the correct city?');
      setLoading(false);
    }, 3000);

    try {
      setLoading(true);
      const response = await axios.get(
        `https://api.openweathermap.org/data/2.5/weather?q=${city}&appid=${apiKey}&units=metric`
      );

      console.log(response.data)
      clearTimeout(timeout);
      setWeatherData(response.data);

			const lat = response.data.coord.lat;
			const lon = response.data.coord.lon;
			const part = 'minutely,hourly,alerts';
			
			const forecastResponse = await axios.get(
				`https://api.openweathermap.org/data/3.0/onecall?lat=${lat}&lon=${lon}&exclude=${part}&appid=${apiKey}&units=metric`
			);

			console.log(forecastResponse.data);
			const forecastItems = [];
			for (const day of forecastResponse.data.daily) {
          forecastItems.push(
            <CSSTransition
            key="data"
            timeout={500}
            classNames="weather-staggered"
          >
            <div className="s3 carousel-item card" key={day.dt}>
              <div className='card-content'>
              <p>{new Date(day.dt * 1000).toDateString()}</p>
              <p>Temperature: {day.temp.day}°C</p>
              <p>Weather: {day.weather[0].description}</p>
              </div>
            </div>
            </CSSTransition>
          );
        };

      setForecastData(forecastItems);
      setLoading(false);
      
    } catch (error) {
      console.error('Error fetching weather data:', error);
      setError('Error fetching weather data. Did you enter the correct city?');
      setLoading(false);
    }
  };

	useEffect(() => {
    if (weatherData && counter < 5) {
      const timer = setTimeout(() => {
        setCounter(counter + 1);
      }, 200);
      return () => clearTimeout(timer);
    } else if (counter === 5) {
      const timer = setTimeout(() => {
        setIsRowAppended(true);
        
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, [weatherData, counter, isRowAppended]);

  return (
    <div className='section' id='main'>
      <div className='section'>
      <input type="text" value={city} onChange={handleInputChange} placeholder='Enter your city here...'/>
      </div>
      <button onClick={getWeatherData} className='waves-effect waves-light btn'>
        {loading ? (
          <svg width="24" height="36" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><rect x="1" y="6" width="2.8" height="12"><animate id="spinner_CcmT" begin="0;spinner_IzZB.end-0.1s" attributeName="y" calcMode="spline" dur="0.6s" values="6;1;6" keySplines=".36,.61,.3,.98;.36,.61,.3,.98"/><animate begin="0;spinner_IzZB.end-0.1s" attributeName="height" calcMode="spline" dur="0.6s" values="12;22;12" keySplines=".36,.61,.3,.98;.36,.61,.3,.98"/></rect><rect x="5.8" y="6" width="2.8" height="12"><animate begin="spinner_CcmT.begin+0.1s" attributeName="y" calcMode="spline" dur="0.6s" values="6;1;6" keySplines=".36,.61,.3,.98;.36,.61,.3,.98"/><animate begin="spinner_CcmT.begin+0.1s" attributeName="height" calcMode="spline" dur="0.6s" values="12;22;12" keySplines=".36,.61,.3,.98;.36,.61,.3,.98"/></rect><rect x="10.6" y="6" width="2.8" height="12"><animate begin="spinner_CcmT.begin+0.2s" attributeName="y" calcMode="spline" dur="0.6s" values="6;1;6" keySplines=".36,.61,.3,.98;.36,.61,.3,.98"/><animate begin="spinner_CcmT.begin+0.2s" attributeName="height" calcMode="spline" dur="0.6s" values="12;22;12" keySplines=".36,.61,.3,.98;.36,.61,.3,.98"/></rect><rect x="15.4" y="6" width="2.8" height="12"><animate begin="spinner_CcmT.begin+0.3s" attributeName="y" calcMode="spline" dur="0.6s" values="6;1;6" keySplines=".36,.61,.3,.98;.36,.61,.3,.98"/><animate begin="spinner_CcmT.begin+0.3s" attributeName="height" calcMode="spline" dur="0.6s" values="12;22;12" keySplines=".36,.61,.3,.98;.36,.61,.3,.98"/></rect><rect x="20.2" y="6" width="2.8" height="12"><animate id="spinner_IzZB" begin="spinner_CcmT.begin+0.4s" attributeName="y" calcMode="spline" dur="0.6s" values="6;1;6" keySplines=".36,.61,.3,.98;.36,.61,.3,.98"/><animate begin="spinner_CcmT.begin+0.4s" attributeName="height" calcMode="spline" dur="0.6s" values="12;22;12" keySplines=".36,.61,.3,.98;.36,.61,.3,.98"/></rect></svg>
        ) : 'Get Weather'}
        
        </button>
        {error && <p className='error'>{error}</p>}

        <div className={`result section${isRowAppended ? ' row fade-in-left' : ''}`}>
      <TransitionGroup className={'s3'}>
        {weatherData && counter >= 1 && (
          <CSSTransition
            key="name"
            timeout={500}
            classNames="weather-staggered"> 
						<div className='section weather-section title'>
							<div className='weather-section title'>
            	<h2>{weatherData.name}</h2>
							<img
              src={`http://openweathermap.org/img/w/${weatherData.weather[0].icon}.png`}
              alt="weather icon"
            	/>
              </div>
						</div>
          </CSSTransition>
        )}
        {weatherData && counter >= 2 && (
          <CSSTransition
            key="temp"
            timeout={500}
            classNames="weather-staggered"
          >
            <p>Temperature: {weatherData.main.temp}°C</p>
          </CSSTransition>
        )}
        {weatherData && counter >= 3 && (
          <CSSTransition
            key="description"
            timeout={500}
            classNames="weather-staggered"
          >
            <p>Weather: {weatherData.weather[0].description}</p>
          </CSSTransition>
        )}
        {weatherData && counter >= 4 && (
          <CSSTransition
            key="humidity"
            timeout={500}
            classNames="weather-staggered"
          >
            <p>Humidity: {weatherData.main.humidity}%</p>
          </CSSTransition>
        )}
        {weatherData && counter >= 5 && (
          <CSSTransition
            key="wind"
            timeout={500}
            classNames="weather-staggered"
          >
            <p>Wind Speed: {weatherData.wind.speed} km/h</p>
          </CSSTransition>
        )}
      </TransitionGroup>
      <div style={{gap:5 + "px"}} className={`row weather-section right hide-on-med-and-down	s9 fade-in-left ${isRowAppended ? 'show' : 'hidden'}`}>
      {forecastData}
      </div>
      </div>
    </div>
  );
};

export default Weather;
